<template>
  <b-container fluid>
    <div class="row-cols-lg-2" v-if="authenticated">
      <b-table-simple hover small caption-top responsive>
        <b-tbody>
          <b-tr >
            <b-th>Name of organization</b-th>
            <b-td>
              {{ this.user.org.businessName }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>Name of user</b-th>
            <b-td>
              {{ this.user.firstName + ' ' + this.user.lastName }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>User role</b-th>
            <b-td>
              {{ hasMnitAdminRole || hasMdhAdminRole || hasOrgAdminRole || hasOrgUserRole }}
            </b-td>
          </b-tr>
          <b-tr>
            <b-th>Facility name(s)</b-th>
            <b-td>
              <b-list-group-item v-for="facility in facilities" :key="facility.name"> {{ facility.facilityName }} </b-list-group-item>
            </b-td>
          </b-tr>
        </b-tbody>
      </b-table-simple>
    </div>
  </b-container>
</template>

<script>
import {roleService} from "@/mixins/roleService";
import axios from "axios";

export default {
  mixins: [
    roleService
  ],
  components: {
  },
  data: () => ({
    results: [],
    user: {
      id: "",
      iamId: "",
      emailAddress: "",
      firstName: "",
      jobTitle: "",
      lastName: "",
      middleName: "",
      phoneNumber: "",
      requestStatus: "",
      org: "",
      primary: Boolean,

      userRole: [],
    },
    facilities: [],
  }),

  computed: {
    authenticated: function() {
      if (this.$keycloak) {
        return this.$keycloak.authenticated;
      } else {
        return false;
      }
    },
    hasMnitAdminRole() {
      if(this.$keycloak.authenticated) {
        return (this.$keycloak.hasResourceRole('mnit-admin')) ? 'MNIT Admin' : ""
      }
      else{
        return ""
      }
    },
    hasMdhAdminRole() {
      if(this.$keycloak.authenticated) {
        return (this.$keycloak.hasResourceRole('mdh-admin')) ? 'MDH Admin' : ""
      }
      else{
        return ""
      }
    },
    hasOrgAdminRole() {
      if(this.$keycloak.authenticated) {
        return (this.$keycloak.hasResourceRole('org-admin')) ? 'Organization Admin' : ""
      }
      else{
        return ""
      }
    },
    hasOrgUserRole() {
      if(this.$keycloak.authenticated) {
        return (this.$keycloak.hasResourceRole('org-user')) ? 'Organization User' : ""
      }
      else{
        return ""
      }
    }

  },

  mounted() {
    this.loadEmployer();
  },

  methods: {
    loadEmployer() {
      axios.get(`${process.env.VUE_APP_API_BASE_URL}/user`).then(response => {
        if (response.status === 200) {
          this.user = response.data
          axios.get(`${process.env.VUE_APP_API_BASE_URL}/user/facilities/${this.user.emailAddress}`)
            .then(response => {
              if (response.status === 200) {
                this.facilities = response.data;
              }
            })
        }
      })
    },
  }
}

</script>

<style scoped>

</style>
